module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('transaction-id')) ? _c('div', {
    staticClass: "field-transaction-id-and-date"
  }, [_c('div', {
    staticClass: "transaction-id"
  }, [_vm._v("TR" + _vm._s(_vm.item.id))])]) : (_vm.$is('transaction-date')) ? _c('div', {
    staticClass: "field-transaction-id-and-date"
  }, [_c('div', {
    staticClass: "trasaction-date"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('transaction-client')) ? _c('div', {
    staticClass: "field-transaction-client"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.client_id
        }
      }
    }
  }, [(_vm.item.client_organization_name) ? _c('span', [_vm._v(_vm._s(_vm.item.client_organization_name))]) : _c('span', [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])])], 1) : (_vm.$is('transaction-payment-method')) ? _c('div', {
    staticClass: "field-transaction-payment-method"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("PM" + _vm._s(_vm.item.payment_method_id))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.payment_name))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.payment_method_provider))])]) : (_vm.$is('transaction-created')) ? _c('div', {
    staticClass: "field-transaction-created"
  }, [_c('div', {
    staticClass: "trasaction-date"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('transaction-amount')) ? _c('div', {
    staticClass: "field-transaction-amount"
  }, [_c('div', {
    staticClass: "field",
    style: (_vm.item.amount < 0 ? 'color:#cc4b37' : '')
  }, [_vm._v(_vm._s(_vm.item.amount.toFixed(2)) + _vm._s(_vm.currency))])]) : (_vm.$is('transaction-status')) ? _c('div', {
    staticClass: "field-transaction-status"
  }, [_c('p', {
    staticClass: "label",
    class: {
      alert: _vm.item.status !== 'SUCCESS'
    }
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('p', [_vm._v(_vm._s(_vm.item.response.message))])]) : (_vm.$is('transaction-date')) ? _c('div', {
    staticClass: "field-transaction-date"
  }, [_c('p', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('invoice-link')) ? _c('div', {
    staticClass: "field-invoice-link"
  }, [(_vm.item.invoice.id) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'invoice',
        params: {
          id: _vm.item.invoice.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.invoice.type) + _vm._s(_vm.item.invoice_internal_id) + " (" + _vm._s(_vm.item.invoice_id) + ")")])]) : _c('p', [_vm._v("not invoiced yet")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-043fdb71!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/TransactionFields.vue
// module id = 2221
// module chunks = 1